export function unique(data: Array<any>) : Array<any> {
    return data.filter((x, i, a) => a.indexOf(x) === i);
}

type DataRecord = any;//;Record<string, any>;
type LabelExtractor = (record: DataRecord) => string;
type ValueExtractor = (record: DataRecord) => string|number;

interface SelectOption {
    label: string,
    value: any,
}

export function createSelectOptions(data: Array<DataRecord>, valueProperty: string|number|ValueExtractor, labelProperty: string|LabelExtractor) : Array<SelectOption> {
    const options: Array<SelectOption> = [];

    data.forEach(record => {
        const value = typeof valueProperty === 'function' ? valueProperty(record) : record[valueProperty];
        if( options.some(option => option.value === value) ) {
            return;
        }
        options.push({
            label: typeof labelProperty === 'function' ? labelProperty(record) : record[labelProperty],
            value,
        });
    });

    return options;
}
